import { z } from 'zod';

export const funcaoFormSchema = z
  .object({
    nome: z.string().trim().min(1, 'Informe o nome da função'),
  })
  .passthrough();

export type FuncaoFormValues = z.infer<typeof funcaoFormSchema>;
